import { BankAccount } from '@features/bankAccounts/types/bankAccount'
import { OpenBankingAccount } from '@features/openBanking/types/openBankingAccount'

export const getAccountData = (connectedAccount?: OpenBankingAccount | BankAccount) => {
  if (!connectedAccount) {
    return
  }

  // BankConnection
  if ('balance' in connectedAccount) {
    const { balance, connection, currency, externalAccountId, id, type, name: accountName } = connectedAccount
    return { accountName, balance, connection, currency, externalAccountId, id, type }
  }

  // BankAccount
  if ('bookedBalance' in connectedAccount) {
    const { bookedBalance, currency, bookkeepingAccountId, id, type, accountName } = connectedAccount
    return {
      accountName,
      balance: bookedBalance?.value,
      connection: undefined,
      currency,
      externalAccountId: bookkeepingAccountId,
      id,
      type,
    }
  }
}
